import script from "./userExamine.vue?vue&type=script&setup=true&lang=js"
export * from "./userExamine.vue?vue&type=script&setup=true&lang=js"

import "./userExamine.vue?vue&type=style&index=0&id=c45cc312&lang=scss"

const __exports__ = script;

export default __exports__